import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountSentimentReportAverageTimeSeriesApplicationService } from '../../../core/application/services/sentiment/get-account-sentiment-report-average-time-series.application-service';
import { AccountSentimentReportAverageTimeSeriesAggregateRoot } from '../../../core/domain/aggregates/sentiment/account-sentiment-report-average-time-series.aggregate-root';
import { GetAccountSentimentReportAverageTimeSeriesRequestDto } from '../../dtos/sentiment/get-account-sentiment-report-average-time-series.request.dto';

export class GetAccountSentimentReportAverageTimeSeriesQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountSentimentReportAverageTimeSeriesApplicationService
  ) {}
  async execute(
    props: GetAccountSentimentReportAverageTimeSeriesRequestDto
  ): Promise<AccountSentimentReportAverageTimeSeriesAggregateRoot[]> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
